module.exports = __webpack_public_path__ + "step4_M2F_kanai_bridal.5f2f6d5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_M2F_kanai_bridal.jpg
// module id = Ebbu
// module chunks = 0